import _ from '@lodash';
import * as Actions from '../Actions/ArquivoActions';

const initialState = {
    data: null,
    pastas: null,
    arquivoDialog: {
        type: 'new',
        props: {
            open: false,
            error: null,
            warning: null,
            info: null,
            isImage: 0
        },
        data: null
    },
    selected: null,
    error: null,
    warning: null,
    info: null,
    preload: false,
};

const ArquivoReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_ARQUIVOS:
            {
                return {
                    ...state,
                    data: action.payload
                };
            }
        case Actions.GET_PASTAS:
            {
                return {
                    ...state,
                    pastas: action.payload
                };
            }
        case Actions.GET_ARQUIVO:
            {
                return {
                    ...state,
                    arquivoDialog: {
                        type: 'edit',
                        props: {
                            open: true
                        },
                        data: action.payload
                    }
                };
            }
        case Actions.ARQUIVO_IMAGE:
            {
                var AResponse = [];
                if (!_.isUndefined(state.data) && !_.isNull(state.data)) {
                    state.data.forEach(item => {
                        if (item.idarquivo === action.id) {
                            item.width = action.payload.width ? action.payload.width : 512;
                            item.height = action.payload.height ? action.payload.height : 512;
                            item.thumbnail = action.payload.base64;
                            item.base64 = action.payload.base64;
                        }
                        AResponse.push(item);
                    });
                }

                return {
                    ...state,
                    data: AResponse
                };
            }
        case Actions.OPEN_NEW_ARQUIVO_DIALOG:
            {
                return {
                    ...state,
                    arquivoDialog: {
                        type: 'new',
                        props: {
                            open: true,
                            isImage: action.isImage === 1 ? 1 : 0
                        },
                        data: null
                    }
                };
            }
        case Actions.CLOSE_NEW_ARQUIVO_DIALOG:
            {
                return {
                    ...state,
                    arquivoDialog: {
                        type: 'new',
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.OPEN_EDIT_ARQUIVO_DIALOG:
            {
                return {
                    ...state,
                    arquivoDialog: {
                        type: 'edit',
                        props: {
                            open: true,
                            xappRouteParams: action.xappRouteParams

                        },
                        data: action.data
                    }
                };
            }
        case Actions.CLOSE_EDIT_ARQUIVO_DIALOG:
            {
                return {
                    ...state,
                    arquivoDialog: {
                        type: 'edit',
                        props: {
                            open: false
                        },
                        data: null
                    }
                };
            }
        case Actions.ARQUIVO_INFO_UPLOAD:
            {
                return {
                    ...state,
                    success: true,
                    arquivoDialog: {
                        type: 'new',
                        props:
                        {
                            open: true,
                            info: action.payload,
                            id: action.id,
                            nome: action.nome
                        },
                        data: null
                    }
                };
            }
        case Actions.ARQUIVO_INFO:
            {
                return {
                    ...state,
                    info: action.payload
                };
            }
        case Actions.ARQUIVO_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload
                };
            }
        case Actions.ARQUIVO_ERROR:
            {
                return {
                    ...state,
                    error: action.payload
                };
            }
        case Actions.ARQUIVO_ERROR_UPLOAD:
            {
                return {
                    ...state,
                    success: true,
                    arquivoDialog: {
                        type: 'new',
                        props:
                        {
                            open: true,
                            error: action.payload,
                            nome: action.nome
                        },
                        data: null
                    }
                };
            }
        case Actions.SET_SELECTED_ARQUIVO:
            {
                var ASelected = null;
                var AArquivo = null;
                if (action.payload !== null) {
                    if (state.selected !== null && _.findIndex(state.selected, { idarquivo: action.payload }) >= 0) {
                        ASelected = _.filter(state.selected, item => item.idarquivo !== action.payload);
                    }
                    else {
                        ASelected = state.selected;
                        if (state.selected === null) {
                            ASelected = [];
                        }
                        AArquivo = _.find(state.data, { idarquivo: action.payload });
                        ASelected.push(AArquivo);
                    }
                }

                return {
                    ...state,
                    selected: ASelected
                };
            }
        case Actions.ARQUIVO_DOWNLOAD:
            {
                var AResponse = [];
                if (!_.isUndefined(state.data) && !_.isNull(state.data)) {
                    state.data.forEach(item => {
                        if (item.idarquivo === action.id) {
                            item.downloading = true;
                        }
                        AResponse.push(item);
                    });
                }

                return {
                    ...state,
                    data: AResponse
                };
            }
        case Actions.ARQUIVO_CHANGE_PRELOAD:
            {
                return {
                    ...state,
                    preload: !state.preload
                };
            }
        default:
            {
                return state;
            }
    }
};

export default ArquivoReducer;
